const loan = require('@/apps/demo/api/loan');

let api = {};

Object.assign(api, loan.default)

export default api;
